var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "bv-example-row" },
    [
      _c("Header"),
      _vm._v(" "),
      _c(
        "b-row",
        [_c("b-col", { staticClass: "hr", attrs: { cols: "12" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-row",
                { staticClass: "border" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "head", attrs: { cols: "12" } },
                            [
                              _c("h4", [
                                _vm._v(":: Auditoría de catálogo Salesforce")
                              ]),
                              _vm._v(" "),
                              _c("small", { staticClass: "text-muted" }, [
                                _vm._v(
                                  "\n                Datos crudos del reporte oficial de Salesforce. No modifica el catálogo del cotizador.\n              "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.stats
                        ? _c(
                            "b-row",
                            { staticClass: "mt-2" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-2",
                                  attrs: { cols: "6", md: "3", lg: "2" }
                                },
                                [
                                  _c("div", { staticClass: "kpi" }, [
                                    _c("div", { staticClass: "kpi-value" }, [
                                      _vm._v(_vm._s(_vm.stats.total_catalogo))
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "kpi-label" }, [
                                      _vm._v("Productos")
                                    ])
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-2",
                                  attrs: { cols: "6", md: "3", lg: "2" }
                                },
                                [
                                  _c("div", { staticClass: "kpi" }, [
                                    _c("div", { staticClass: "kpi-value" }, [
                                      _vm._v(_vm._s(_vm.marcas.length))
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "kpi-label" }, [
                                      _vm._v("Marcas")
                                    ])
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-2",
                                  attrs: { cols: "6", md: "3", lg: "2" }
                                },
                                [
                                  _c("div", { staticClass: "kpi" }, [
                                    _c("div", { staticClass: "kpi-value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.stats
                                            ? _vm.stats.modelos_distintos
                                            : 0
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "kpi-label" }, [
                                      _vm._v("Modelos")
                                    ])
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-2",
                                  attrs: { cols: "6", md: "3", lg: "2" }
                                },
                                [
                                  _c("div", { staticClass: "kpi" }, [
                                    _c("div", { staticClass: "kpi-value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.stats
                                            ? _vm.stats.versiones_distintas
                                            : 0
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "kpi-label" }, [
                                      _vm._v("Versiones")
                                    ])
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-2",
                                  attrs: { cols: "12", md: "6", lg: "4" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "kpi kpi-flags" },
                                    [
                                      _vm._l(_vm.statsFlags, function(f) {
                                        return _c(
                                          "b-badge",
                                          {
                                            key: f.nombre,
                                            staticClass: "mr-1 mb-1",
                                            attrs: {
                                              variant: _vm.variantDe(f.nombre)
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.etiquetaDe(f.nombre)) +
                                                ": " +
                                                _vm._s(f.total)
                                            )
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      !_vm.statsFlags.length
                                        ? _c(
                                            "span",
                                            { staticClass: "text-muted small" },
                                            [_vm._v("Sin incidencias")]
                                          )
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mt-3" },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "mb-2",
                              attrs: { cols: "12", md: "6", lg: "2" }
                            },
                            [
                              _c("b-form-select", {
                                attrs: { options: _vm.opcionesMarca },
                                on: { change: _vm.alCambiarMarca },
                                model: {
                                  value: _vm.filtro.brand,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filtro, "brand", $$v)
                                  },
                                  expression: "filtro.brand"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "mb-2",
                              attrs: { cols: "12", md: "6", lg: "2" }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  options: _vm.opcionesModelo,
                                  disabled: !_vm.filtro.brand
                                },
                                on: { change: _vm.alCambiarModelo },
                                model: {
                                  value: _vm.filtro.model,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filtro, "model", $$v)
                                  },
                                  expression: "filtro.model"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "mb-2",
                              attrs: { cols: "12", md: "6", lg: "2" }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { placeholder: "Versión (parcial)" },
                                on: {
                                  keyup: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.buscar.apply(null, arguments)
                                  }
                                },
                                model: {
                                  value: _vm.filtro.version,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filtro, "version", $$v)
                                  },
                                  expression: "filtro.version"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "mb-2",
                              attrs: { cols: "12", md: "6", lg: "2" }
                            },
                            [
                              _c("b-form-select", {
                                attrs: { options: _vm.opcionesFlag },
                                model: {
                                  value: _vm.filtro.flag,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filtro, "flag", $$v)
                                  },
                                  expression: "filtro.flag"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "mb-2",
                              attrs: { cols: "12", md: "6", lg: "2" }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  placeholder: "Buscar código / SAP..."
                                },
                                on: {
                                  keyup: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.buscar.apply(null, arguments)
                                  }
                                },
                                model: {
                                  value: _vm.filtro.q,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filtro, "q", $$v)
                                  },
                                  expression: "filtro.q"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "mb-2",
                              attrs: { cols: "12", md: "6", lg: "2" }
                            },
                            [
                              _c(
                                "b-button-group",
                                { attrs: { size: "sm" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "primary" },
                                      on: { click: _vm.buscar }
                                    },
                                    [_vm._v("Buscar")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "secondary" },
                                      on: { click: _vm.limpiar }
                                    },
                                    [_vm._v("Limpiar")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  staticClass: "ml-1",
                                  attrs: {
                                    size: "sm",
                                    variant: "outline-success",
                                    disabled: _vm.exportando
                                  },
                                  on: { click: _vm.exportarCsv }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.exportando ? "..." : "CSV") +
                                      "\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mt-1" },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "text-muted small",
                              attrs: { cols: "12" }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.total) +
                                  " producto(s) en la colección\n              "
                              ),
                              _vm.cargando
                                ? _c("span", [_vm._v(" — cargando...")])
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "text-right",
                              attrs: { cols: "12" }
                            },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  staticClass: "small mb-0",
                                  attrs: { switch: "" },
                                  model: {
                                    value: _vm.verTodosLosCampos,
                                    callback: function($$v) {
                                      _vm.verTodosLosCampos = $$v
                                    },
                                    expression: "verTodosLosCampos"
                                  }
                                },
                                [_vm._v("Ver los 14 campos del reporte")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("b-table", {
                        staticClass: "mt-1",
                        attrs: {
                          striped: "",
                          hover: "",
                          small: "",
                          responsive: "",
                          items: _vm.items,
                          fields: _vm.fields,
                          busy: _vm.cargando,
                          "sort-changed": "alOrdenar",
                          "show-empty": "",
                          "empty-text": "No hay productos con esos filtros"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "cell(brand)",
                            fn: function(row) {
                              return [
                                _c("strong", [_vm._v(_vm._s(row.item.brand))])
                              ]
                            }
                          },
                          {
                            key: "cell(model)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(row.item.model || "—") +
                                    "\n            "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(version)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(row.item.version || "—") +
                                    "\n            "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(sap_id)",
                            fn: function(row) {
                              return [
                                row.item.sap_id
                                  ? _c("code", [
                                      _vm._v(_vm._s(row.item.sap_id))
                                    ])
                                  : _c(
                                      "b-badge",
                                      { attrs: { variant: "danger" } },
                                      [_vm._v("sin SAP")]
                                    )
                              ]
                            }
                          },
                          {
                            key: "cell(audit)",
                            fn: function(row) {
                              return [
                                !row.item.audit.flags.length
                                  ? _c(
                                      "span",
                                      { staticClass: "text-success" },
                                      [_vm._v("OK")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(row.item.audit.flags, function(f) {
                                  return _c(
                                    "b-badge",
                                    {
                                      key: f,
                                      staticClass: "mr-1",
                                      attrs: { variant: _vm.variantDe(f) }
                                    },
                                    [_vm._v(_vm._s(_vm.etiquetaDe(f)))]
                                  )
                                })
                              ]
                            }
                          },
                          {
                            key: "cell(code)",
                            fn: function(row) {
                              return [
                                _c("code", [
                                  _vm._v(_vm._s(row.item.code || "—"))
                                ])
                              ]
                            }
                          },
                          {
                            key: "cell(ext_id)",
                            fn: function(row) {
                              return [
                                _c("code", [
                                  _vm._v(_vm._s(row.item.ext_id || "—"))
                                ])
                              ]
                            }
                          },
                          {
                            key: "cell(family)",
                            fn: function(row) {
                              return [_vm._v(_vm._s(row.item.family || "—"))]
                            }
                          },
                          {
                            key: "cell(product_type)",
                            fn: function(row) {
                              return [
                                _vm._v(_vm._s(row.item.product_type || "—"))
                              ]
                            }
                          },
                          {
                            key: "cell(record_type)",
                            fn: function(row) {
                              return [
                                _vm._v(_vm._s(row.item.record_type || "—"))
                              ]
                            }
                          },
                          {
                            key: "cell(business_unit)",
                            fn: function(row) {
                              return [
                                _vm._v(_vm._s(row.item.business_unit || "—"))
                              ]
                            }
                          },
                          {
                            key: "cell(active)",
                            fn: function(row) {
                              return [_vm._v(_vm._s(row.item.active || "—"))]
                            }
                          },
                          {
                            key: "cell(peru)",
                            fn: function(row) {
                              return [_vm._v(_vm._s(row.item.peru || "—"))]
                            }
                          },
                          {
                            key: "cell(created_by)",
                            fn: function(row) {
                              return [
                                _vm._v(_vm._s(row.item.created_by || "—"))
                              ]
                            }
                          },
                          {
                            key: "cell(created_at_raw)",
                            fn: function(row) {
                              return [
                                _vm._v(_vm._s(row.item.created_at_raw || "—"))
                              ]
                            }
                          },
                          {
                            key: "cell(source_row)",
                            fn: function(row) {
                              return [
                                _vm._v(_vm._s(row.item.source_row || "—"))
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _vm.paginas > 1
                        ? _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "d-flex justify-content-center",
                                  attrs: { cols: "12" }
                                },
                                [
                                  _c("b-pagination", {
                                    attrs: {
                                      "total-rows": _vm.total,
                                      "per-page": _vm.porPagina,
                                      "page-options": _vm.opcionesPagina,
                                      type: "button"
                                    },
                                    on: { input: _vm.cargarProductos },
                                    model: {
                                      value: _vm.pagina,
                                      callback: function($$v) {
                                        _vm.pagina = $$v
                                      },
                                      expression: "pagina"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.error
                        ? _c(
                            "b-alert",
                            { attrs: { show: "", variant: "danger" } },
                            [_vm._v(_vm._s(_vm.error))]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d745bcd4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d745bcd4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Auditoria.vue
// module id = null
// module chunks = 